import React from 'react';
import { Typography } from '@material-ui/core';

import { truncateString } from 'helpers/truncateString/truncateString';

import { DataGridCellProps } from './DataGridCell.types';
import { useStyles } from './DataGridCell.styles';

export const DataGridCell = ({ icon, title, description }: DataGridCellProps) => {
  const classes = useStyles({ withTitle: !!title });

  const renderTitle = () => {
    if (typeof title == 'string') {
      return (
        <Typography className={classes.title} data-testid="cell-title">
          {truncateString({ maxLength: 20, string: title })}
        </Typography>
      );
    }

    return title;
  };

  return (
    <div>
      <div className={classes.titleContainer}>
        {icon && (
          <div className={classes.icon} data-testid="cell-icon">
            {icon}
          </div>
        )}
        {title && renderTitle()}
      </div>
      {description && (
        <Typography className={classes.description} data-testid="cell-description">
          {truncateString({ maxLength: 20, string: description })}
        </Typography>
      )}
    </div>
  );
};
